export default {
	address:{
		name: '收件人',
		list: '地址列表',
		address: '地址',
		region: '区号',
		mobile: '电话号码',
		detail: '详细地址',
		save: '保存并使用',
		create: '新建地址',
		inputDetail: '请填写详细信息',
		select: '请输入地址',
		notice: '请填写与身份证明文件相同的名字'
	},
	checkout: '结算',
	totalPrice: '总计',
	noTariff: '不含关税及运费',
	total: '共',
	products: '件商品',
	order: {
		create: '提交订单',
		tariff: '关税',
		shippingFee: '运费',
		discount: '优惠折扣',
		remarks: '买家留言',
		couponCode: '优惠码',
		useCoupon: '使用优惠',		
		shippingMethod : '配送方式',
		selfPickup: '自取',
		mail: '快递',
		orderNumber: '订单号',
		paymentStatus:{
			status: '订单装填',
			P: '等待付款',
			S: '已付款',
			F: '付款失败'
		},
		orderTime: '下单时间',
		totalAmount: '总金额',
		alert: '提醒',
		failAlert: '提交前请确保你已填写地址(如适用)﹐联络电话及确认条款',
		useCredit: '使用积分优惠',
		orderDetail: '帐单详情',
		phoneNumber: '－ 如选择自取只需提供电话号码',
		agree: '本人已阅读并明白及同意',
		agreement: '用户网购条款',
		notice: '－ 客人如果对其准备下单的网购产品有任何疑问﹐请客人不应下单避免不必要的争议。',
		fillUp: '－ 客人请确保已填写',
		address: '地址(如适用)',
		client: '－ 客人请确保已',
		confirm: '确认条款。',
		customerService: '－ 自取地址详情请联络客户服务主任。',
		},
	payment:{
		pay: '确认付款',
		method: '付款方式',
		wechat: '微信付款',
		stripe: '信用卡付款',
		cash: '现金付款',
	    makingPayment: '付款中',
	    errorPayment: '付款失败，请稍后再试',
	    errorCard: '请正确输入信用卡号码',
	   	info: '付款详情',
	    orderNumber: '订单号码',
	    actualAmount: '付款金额',
	    currency: '货币',
	    waitingConfirm: '等待确认',
	    success: '付款成功',
	    backToOrder: '查看我的订单',
	    backToShop: '查看我的商品',	 
	    shareMsg: '到我的商品分享给其他人，能够获得回赠哦！'   
	},
	emptyMsg:{
      cart:'快点给我挑点商品 T.T',
      order:'暂无订单记录',
	},
	logistic: {
		ordered: '未出货',
		packaged: '已包装',
		delivered: '已发货',
		received: '已收货',
		confirm: '确认收货',
		cancel: '取消订单',
		cancelConfirm: '你是否确认取消订单？',
		receiveConfirm: '你是否确认已收取货物？'
	}
}


// WEBPACK FOOTER //
// ./src/Cart/langs/zh_cn/index.js